export interface BatchLendDbUpdateRequest {
  outputMode: string
  fileName: string
  dueDateType: string
  dueDate: string
  batchType: string
}

export function BatchLendDbUpdateRequestToJSON(
  value: BatchLendDbUpdateRequest
): any {
  return {
    output_mode: value.outputMode,
    file_name: value.fileName,
    due_date_type: value.dueDateType,
    due_date: value.dueDate,
    batch_type: value.batchType
  }
}
